<template>
	<button type="button"
		:class="`btn btn-default ${additionalClass}`"
		:disabled="disabled"
		data-dismiss="modal">
		<i class="fa fa-times"></i>
		<span>{{ label }}</span>
	</button>
</template>

<script>
export default {
	props: {
		additionalClass: {
			type: String,
			required: false,
			default: null,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		label: {
			type: String,
			required: false,
			default: 'Tutup',
		},
	}
}
</script>
